import { Button } from '@mantine/core';
import { CSSProperties, forwardRef } from 'react';
import { skyLighter } from '../../styles/design-tokens';
import { Icon } from '../../ui-library/icon/icon';

type Props = {
  onClick: () => void;
  iconName: string;
  style?: CSSProperties;
  'aria-label'?: string;
  visible?: boolean;
};

const SmallSquareButton = forwardRef<HTMLButtonElement, Props>(
  ({ onClick, iconName, style, 'aria-label': ariaLabel, visible = true }, ref) => {
    if (!visible) {
      return null;
    }

    return (
      <Button ref={ref} size="xs" onClick={onClick} color={skyLighter} px={4} style={style} aria-label={ariaLabel}>
        <Icon name={iconName} size={20} style={{ cursor: 'pointer' }} />
      </Button>
    );
  },
);

SmallSquareButton.displayName = 'SmallSquareButton';

export { SmallSquareButton };
